var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "doctor-documents-plate" },
    [
      _setup.hasContent
        ? _c(
            "button",
            {
              staticClass: "doctor-documents-plate__button align-center",
              class: [
                _setup.plateClass,
                { "doctor-documents-plate__button--desktop": !_setup.isMobile },
              ],
              attrs: {
                type: "button",
                "data-qa": "lpu_doctors_list_documents",
              },
              on: { click: _setup.onPlateClick },
            },
            [
              _c("div", { staticClass: "text-left mr-2 min-w-0" }, [
                _setup.experienceLabel
                  ? _c("div", { staticClass: "text-subtitle-1" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.tStatic("Стаж")) +
                          " " +
                          _vm._s(_setup.experienceLabel) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _setup.categoryLabel || _setup.scienceLabel
                  ? _c("div", [
                      _setup.categoryLabel
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "text-body-2 doctor-documents-plate__dot",
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_setup.categoryLabel) +
                                  " " +
                                  _vm._s(_setup.tStatic("категория")) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _setup.scienceLabel
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "text-body-2 doctor-documents-plate__dot",
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_setup.scienceLabel) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.doctor.has_trust_sign && _setup.hasFakeDocuments
                  ? _c("div", { staticClass: "text-body-2 text-error--text" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _setup.tStatic(
                              "Факт выдачи части документов опровергнут"
                            )
                          ) +
                          "\n      "
                      ),
                    ])
                  : _vm.doctor.has_trust_sign
                  ? _c(
                      "div",
                      { staticClass: "d-flex align-center text-body-2" },
                      [
                        _c("span", {
                          staticClass:
                            "ui-icon-shield-check ui-icon-fz-smaller mr-1",
                        }),
                        _vm._v(
                          "\n        " +
                            _vm._s(_setup.tStatic("Документы проверены")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.doctor.has_trust_sign
                ? _c("div", {
                    staticClass:
                      "ui-icon-arrow-right ui-icon-fz-big ml-auto flex-shrink-0",
                  })
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.doctor.has_trust_sign
        ? _c(_setup.DoctorDocumentsModal, {
            attrs: { documents: _setup.documentsPayload },
            model: {
              value: _setup.isDocumentsOpen,
              callback: function ($$v) {
                _setup.isDocumentsOpen = $$v
              },
              expression: "isDocumentsOpen",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }